export { default, InputAdornmentProps } from '@material-ui/core/InputAdornment';
